module.exports = __webpack_public_path__ + "img/filter-welcome-background-kia.921c51c9.png";